import { SIDENAV_ACTION_TYPES } from "../../_constants";

const toggleNav = (status) => {
   return { type: SIDENAV_ACTION_TYPES.TOGGLE, status};
}

export const sideNavActions = {
    toggleNav
};
